import { useMenu } from "../../../contexts/menu/menu.hook";
import { MenuContentOptions } from "../../../contexts/menu/Menu.types";

export const MenuContentNavigation = ({
  buyTicketsLink,
}: {
  buyTicketsLink: string;
}) => {
  const { setIsMenuOpen, setMenuContent } = useMenu();

  return (
    <nav
      style={{
        display: "contents",
      }}
    >
      <button onClick={() => setIsMenuOpen(false)}>Home</button>
      {buyTicketsLink && (
        <a href={buyTicketsLink} target="_blank" rel="noreferrer">
          Buy movie ticket
        </a>
      )}
      <button onClick={() => setMenuContent(MenuContentOptions.TRAILER)}>
        Trailer
      </button>
      <button onClick={() => setMenuContent(MenuContentOptions.SYNOPSIS)}>
        Synopsis
      </button>
    </nav>
  );
};
